import { 
    ACTUALIZAR_LIST_INFORMES,
    AGREGAR_INFORMES,
    MODIFICAR_INFORMES,
  } from "./informesActions";

  const InformesReducer = (state, action) => {
    switch(action.type){

        case ACTUALIZAR_LIST_INFORMES: {
            return {
                ...state,
                informesList: action.payload
            }
        };

        case AGREGAR_INFORMES:{
            return {
                 ...state,
                 informesList: [action.payload, ...state.informesList]
             }
         };

        case MODIFICAR_INFORMES: {
            return {
                ...state,
                informesList: state.informesList.map((g) => g._id === action.payload._id ? action.payload : g)
            }
        };

        default: return state;
    }
  }

  export default InformesReducer;